<template>
  <div>
    <FormSections
      :config="configValues"
      :vuelidate="$v"
      :custom-allowed="true"

      @updated="previewConfig"
      @delete-field="deleteField"
    />
  </div>
</template>

<script>

import FormSections from "./Components/FormSections.vue"
import FormCheckbox from "../../Inputs/FormCheckbox.vue"

const tailwindColors = ["transparent", "black", "white", "slate", "gray", "zinc", "neutral", "stone", "red", "orange", "amber", "yellow", "lime", "green", "emerald", "teal", "cyan", "sky", "blue", "indigo", "violet", "purple", "fuchsia", "pink", "rose"]

const defaultConfig = {
  "colors": {
    id: 'colors',
    title: "Custom colors",
    type: 'color',
    newField: {
      idPlaceholder: "Color id... e.g: 'tertiary'",
      labelPlaceholder: "Color label... e.g: 'Tertiary color'",
      newFieldPlaceholder: "New color",
      examplePrefix: 'text-',
    },
    fields: [
      {
        id: "primary",
        label: "Primary",
        deletable: false,
        // required: true,
      },
      {
        id: "secondary",
        label: "Secondary",
        deletable: false,
        // required: true,
      },
      {
        id: "tertiary",
        label: "Tertiary",
        deletable: false,
        // required: true,
      },
    ],
  },
  'screens': {
    id: 'screens',
    title: 'Breakpoints(screens)',
    newField: {
      idPlaceholder: "Breakpoint id... e.g: 'sm'",
      labelPlaceholder: "Breakpoint label... e.g: 'Mobile'",
      newFieldPlaceholder: "New breakpoint",
      exampleSuffix: ':flex-col',
    },
    fields: [
      {
        id: "sm",
        label: "Mobile",
        default: '640px',
        deletable: false,
      },
      {
        id: "md",
        label: "Tablet",
        default: '770px',
        deletable: false,
      },
      {
        id: "lg",
        label: "Laptop",
        default: '1024px',
        deletable: false,
      },
      {
        id: "xl",
        label: "Bigger Screens",
        default: '1280px',
        deletable: false,
      },
      {
        id: "2xl",
        label: "Extra Large",
        default: '1280px',
        deletable: false,
      },
    ],
  },
  'maxWidth': {
    id: 'maxWidth',
    title: 'Max width classes',
    newField: {
      idPlaceholder: "Value id... e.g: 'lg'",
      labelPlaceholder: "Value label... e.g: 'Large'",
      newFieldPlaceholder: "New value",
      examplePrefix: 'max-w-',
    },
    fields: [
      {
        id: "pages",
        label: "Pages CMS Max Width",
        default: '56rem',
        deletable: false,
      },
    ],
  },
}

const allAvailaleColors = {
  transparent: 'transparent',
  black: '#000',
  white: '#fff',
  slate: {
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#64748b',
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
  },
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },
  zinc: {
    50: '#fafafa',
    100: '#f4f4f5',
    200: '#e4e4e7',
    300: '#d4d4d8',
    400: '#a1a1aa',
    500: '#71717a',
    600: '#52525b',
    700: '#3f3f46',
    800: '#27272a',
    900: '#18181b',
  },
  neutral: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  stone: {
    50: '#fafaf9',
    100: '#f5f5f4',
    200: '#e7e5e4',
    300: '#d6d3d1',
    400: '#a8a29e',
    500: '#78716c',
    600: '#57534e',
    700: '#44403c',
    800: '#292524',
    900: '#1c1917',
  },
  red: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d',
  },
  orange: {
    50: '#fff7ed',
    100: '#ffedd5',
    200: '#fed7aa',
    300: '#fdba74',
    400: '#fb923c',
    500: '#f97316',
    600: '#ea580c',
    700: '#c2410c',
    800: '#9a3412',
    900: '#7c2d12',
  },
  amber: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
  },
  yellow: {
    50: '#fefce8',
    100: '#fef9c3',
    200: '#fef08a',
    300: '#fde047',
    400: '#facc15',
    500: '#eab308',
    600: '#ca8a04',
    700: '#a16207',
    800: '#854d0e',
    900: '#713f12',
  },
  lime: {
    50: '#f7fee7',
    100: '#ecfccb',
    200: '#d9f99d',
    300: '#bef264',
    400: '#a3e635',
    500: '#84cc16',
    600: '#65a30d',
    700: '#4d7c0f',
    800: '#3f6212',
    900: '#365314',
  },
  green: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
  },
  emerald: {
    50: '#ecfdf5',
    100: '#d1fae5',
    200: '#a7f3d0',
    300: '#6ee7b7',
    400: '#34d399',
    500: '#10b981',
    600: '#059669',
    700: '#047857',
    800: '#065f46',
    900: '#064e3b',
  },
  teal: {
    50: '#f0fdfa',
    100: '#ccfbf1',
    200: '#99f6e4',
    300: '#5eead4',
    400: '#2dd4bf',
    500: '#14b8a6',
    600: '#0d9488',
    700: '#0f766e',
    800: '#115e59',
    900: '#134e4a',
  },
  cyan: {
    50: '#ecfeff',
    100: '#cffafe',
    200: '#a5f3fc',
    300: '#67e8f9',
    400: '#22d3ee',
    500: '#06b6d4',
    600: '#0891b2',
    700: '#0e7490',
    800: '#155e75',
    900: '#164e63',
  },
  sky: {
    50: '#f0f9ff',
    100: '#e0f2fe',
    200: '#bae6fd',
    300: '#7dd3fc',
    400: '#38bdf8',
    500: '#0ea5e9',
    600: '#0284c7',
    700: '#0369a1',
    800: '#075985',
    900: '#0c4a6e',
  },
  blue: {
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
  },
  indigo: {
    50: '#eef2ff',
    100: '#e0e7ff',
    200: '#c7d2fe',
    300: '#a5b4fc',
    400: '#818cf8',
    500: '#6366f1',
    600: '#4f46e5',
    700: '#4338ca',
    800: '#3730a3',
    900: '#312e81',
  },
  violet: {
    50: '#f5f3ff',
    100: '#ede9fe',
    200: '#ddd6fe',
    300: '#c4b5fd',
    400: '#a78bfa',
    500: '#8b5cf6',
    600: '#7c3aed',
    700: '#6d28d9',
    800: '#5b21b6',
    900: '#4c1d95',
  },
  purple: {
    50: '#faf5ff',
    100: '#f3e8ff',
    200: '#e9d5ff',
    300: '#d8b4fe',
    400: '#c084fc',
    500: '#a855f7',
    600: '#9333ea',
    700: '#7e22ce',
    800: '#6b21a8',
    900: '#581c87',
  },
  fuchsia: {
    50: '#fdf4ff',
    100: '#fae8ff',
    200: '#f5d0fe',
    300: '#f0abfc',
    400: '#e879f9',
    500: '#d946ef',
    600: '#c026d3',
    700: '#a21caf',
    800: '#86198f',
    900: '#701a75',
  },
  pink: {
    50: '#fdf2f8',
    100: '#fce7f3',
    200: '#fbcfe8',
    300: '#f9a8d4',
    400: '#f472b6',
    500: '#ec4899',
    600: '#db2777',
    700: '#be185d',
    800: '#9d174d',
    900: '#831843',
  },
  rose: {
    50: '#fff1f2',
    100: '#ffe4e6',
    200: '#fecdd3',
    300: '#fda4af',
    400: '#fb7185',
    500: '#f43f5e',
    600: '#e11d48',
    700: '#be123c',
    800: '#9f1239',
    900: '#881337',
  },
}
const allTailwindColors = Object.keys(allAvailaleColors).reduce((arr, color) => {
  if (typeof allAvailaleColors[color] === "string") return [...arr, color]
  return [
    ...arr,
    ...Object.keys(allAvailaleColors[color]).reduce((tints, tint) => {
      return [...tints, `${color}-${tint}`]
    }, [])
  ]
}, [])


const dataTailwind = tailwindColors.reduce((all, color) => {
  if (typeof allAvailaleColors[color] === "string") return {...all, [color]: ""}
  const keys = Object.keys(allAvailaleColors[color])

  return {
    ...all,
    [color]: keys.reduce((obj, tint) => ({
      ...obj,
      [`${color}-${tint}`]: "",
    }), {})
  }
}, {})
const dataTailwindKeys = Object.keys(dataTailwind)

const generalColors = ['white', 'black', 'transparent']
const isGeneralColor = color => generalColors.includes(color)
const isColorFromTailwindDefault = color => generalColors.includes(color) || allTailwindColors.includes(color)

export default {
  props: {
    initialConfig: Object,
    availableColors: Array,
  },
  components: {
    FormSections,
    FormCheckbox,
  },
  validations() {
    const config = this.config
    const keys = Object.keys(config)
    return keys.reduce((obj, key) => ({
      ...obj,
      [key]: config[key].fields.reduce((childObj, field) => ({
        ...childObj,
        [field.id]: {},
      }), {})
    }), {})
  },
  created() {
    let initialConfig
    if (this.initialConfig && this.initialConfig.tailwindConfig && this.initialConfig.tailwindConfig.extend) {
      initialConfig = this.initialConfig.tailwindConfig.extend
      const labels = this.initialConfig.labels
      Object.keys(initialConfig).forEach(sectionKey => {
        Object.keys(initialConfig[sectionKey]).forEach(fieldKey => {
          if (sectionKey === 'colors' && isColorFromTailwindDefault(fieldKey)) return;
          
          const fields = this.defaultConfig[sectionKey].fields
          if (!fields.some(field => field.id === fieldKey)) {
            fields.push({
              id: fieldKey,
              label: labels ? (labels[sectionKey][fieldKey] || fieldKey) : fieldKey,
            })
          }
        })
      })
      Object.keys(initialConfig.colors || {}).filter(color => isColorFromTailwindDefault(color)).forEach(color => {
        if (color.includes("-")) {
          const splitted = color.split("-")
          const base = splitted[0]
          const id = base + "-" + splitted[1]

          if (!this.$v[`tailwind_${base}`]) return;
          this.$v[`tailwind_${base}`][id].$model = initialConfig.colors[id] || ""
        } else {
          this.$v[`tailwind_general`][color].$model = initialConfig.colors[color] || ""
        }
      })
    }
    Object.keys(this.config).forEach(sectionKey => {  
      this.config[sectionKey].fields.forEach(field => {
        if (sectionKey.includes("tailwind_") && isColorFromTailwindDefault(field.id)) return;
        
        this.$v[sectionKey][field.id].$model = (initialConfig && initialConfig[sectionKey] && initialConfig[sectionKey][field.id]) || field.default || ''
      })
    })
  },
  data() {
    return {
      defaultConfig,
      ...Object.keys(defaultConfig).reduce((obj, key) => ({ ...obj, [key]: {} }), {}),
      ...Object.keys(dataTailwind).reduce((obj, color) => {
        if (!isGeneralColor(color)) {
          return {
            ...obj,
            [`tailwind_${color}`]: dataTailwind[color], 
          }
        }
        return {
          ...obj,
          [`tailwind_general`]: {
            ...obj[`tailwind_general`],
            ...dataTailwind[color],
          }
        }
      }, {}),
    }
  },
  methods: {
    deleteField({section, id}) {
      this.$emit("remove-path", `tailwindConfig.extend.${section}.${id}`)
    },
    previewConfig() {
      const $v = this.$v

      const config = this.config
      const keys = Object.keys(config)
      const theme = keys.reduce((obj, sectionId) => {
        const values = config[sectionId].fields.filter(field => {
            // Fields whose default values don't change don't need to be incluced on the config.
            const model = $v[sectionId][field.id].$model

            if (!model && field.deletable === false) return false
            if (!field.default) return true
            return model !== field.default
          }).reduce((colors, field) => ({
            ...colors,
            [field.id]: $v[sectionId][field.id].$model,
          }), {})
        if (!Object.keys(values).length) return obj

        return {
          ...obj,
          [sectionId]: values,
        }
      }, {})

      const labels = {}
      Object.keys(theme).forEach(section => {
        Object.keys(theme[section]).forEach(fieldKey => {
          if (!defaultConfig[section]) return;
          if (defaultConfig[section].fields.find(item => item.id === fieldKey).deletable === false) return;
          
          labels[section] = {
            ...labels[section],
            [fieldKey]: this.defaultConfig[section].fields.find(item => item.id === fieldKey).label
          }
        })
      })


      // mergre tailwind_ to colors
      const finalTheme = Object.keys(theme).reduce((obj, key) => {
        if (key.includes("tailwind")) return {
          ...obj,
          colors: {
            ...theme.colors || {},
            ...obj.colors || {},
            ...theme[key]
          }
        }
        return {
          ...obj,
          [key]: {...obj[key], ...theme[key]}
        }
      }, {})
      console.log("THEME: ", theme, finalTheme)
      // ------
      if (!Object.keys(theme).length) return;
      this.$emit("input", {
        tailwindConfig: {
          extend: finalTheme,
        },
        labels,
      })
    },
  },
  computed: {
    config() {
      return {
        ...this.defaultConfig,
        ...this.tailwindDefaultColorsConfig,
      }
    },
    tailwindDefaultColorsConfig() {
      const available = this.availableColors

      let filtered = dataTailwindKeys.filter(key => {
        return available.some(color => color.includes(key))
      })
      const mapped = filtered.reduce((all, key) => {
        if (typeof dataTailwind[key] === "string") return {...all, [key]: allAvailaleColors[key]}
        const colorKeys = Object.keys(dataTailwind[key]).filter(colorKey => available.some(color => color.includes(colorKey)))
        return {
          ...all,
          [key]: colorKeys.reduce((obj, tint) => ({
            ...obj,
            [tint]: allAvailaleColors[key][tint],
          }), {})
        }
      }, {})
      const keys = Object.keys(mapped)

      const depthColors = keys.filter(key => !isGeneralColor(key)).reduce((all, key) => {
        return {
          ...all,
          [`tailwind_${key}`]: {
            id: `tailwind_${key}`,
            title: key[0].toUpperCase() + key.substring(1),
            type: 'color',
            fields: Object.keys(mapped[key]).reduce((colors, tint) => ([
              ...colors,
              {
                id: tint,
                label: (tint.split("-")[1])[0].toUpperCase() + (tint.split("-")[1]).substring(1),
                default: allAvailaleColors[key][tint.split("-")[1]],
                deletable: false,
              }
            ]), []),
          }
        }
      }, {})
      const noDepthKeys = keys.filter(isGeneralColor)

      return {
        ...depthColors,
        [`tailwind_general`]: {
          id: `tailwind_general`,
          title: "General colors",
          type: 'color',
          fields: noDepthKeys.reduce((colors, color) => ([
            ...colors,
            {
              id: color,
              label: color[0].toUpperCase() + color.substring(1),
              default: allAvailaleColors[color],
              deletable: false,
            }
          ]), []),
        }
      }
    },
    configValues() {
      const config = this.config
      const keys = Object.keys(config)

      // const keys = Object.values(this.config)
      keys.sort((a, b) => {
        const isBTailwind = a.includes("tailwind")
        if (b.includes("colors") && isBTailwind) return 1
        if (a.includes("colors") || isBTailwind) return -1
        return 1
      })

      return keys.map(key => config[key])
    },
  },
}

</script>

<style scoped>

p {
  margin: 0;
}

.header-wrapper {
  margin-bottom: 18px;
  padding-bottom: 0px !important;
  font-size: 12px;
}

</style>
